import React from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";

import p from "../img2/img2.jpeg";
import pp from "../img2/img4.jpeg";
import n2 from "../img2/img6.jpeg";
import n3 from "../img2/img5.jpeg";
import n4 from "../img2/img7.jpeg";
const MainWrapper = styled.section`
  direction: rtl;
  padding: 120px 40px;
  position: relative;
  overflow: hidden;

  background:
    radial-gradient(circle at top right,#2563eb 0%,transparent 35%),
    radial-gradient(circle at bottom left,#7c3aed 0%,transparent 30%),
    linear-gradient(135deg,#071426,#0d223f,#112f58);

  &::before{
    content:"";
    position:absolute;
    inset:0;
    background:linear-gradient(
      rgba(255,255,255,.03),
      rgba(255,255,255,.01)
    );
    pointer-events:none;
  }

  @media(max-width:768px){
    padding:80px 20px;
  }
`;

const Title = styled.h1`
  text-align:center;
  color:white;
  font-size:58px;
  font-weight:900;
  margin-bottom:15px;
  letter-spacing:-1px;

  span{
    background:linear-gradient(90deg,#60a5fa,#8b5cf6);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }

  @media(max-width:768px){
    font-size:38px;
  }
`;

const Subtitle = styled.p`
  text-align:center;
  color:#cbd5e1;
  font-size:20px;
  max-width:750px;
  margin:auto;
  line-height:1.8;
  margin-bottom:70px;

  @media(max-width:768px){
    font-size:17px;
  }
`;

const ProjectsGrid = styled.div`
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(320px,1fr));
  gap:35px;
  max-width:1500px;
  margin:auto;
`;

const Card = styled.div`
  position:relative;
  overflow:hidden;
  border-radius:28px;
  cursor:pointer;

  background:rgba(255,255,255,.08);

  backdrop-filter:blur(20px);

  border:1px solid rgba(255,255,255,.12);

  transition:.45s;

  box-shadow:
      0 20px 50px rgba(0,0,0,.35);

  &:hover{
      transform:translateY(-15px) scale(1.03);
      box-shadow:
      0 35px 80px rgba(37,99,235,.45);
  }

  &:before{
      content:"";
      position:absolute;
      inset:0;

      background:
      linear-gradient(
      120deg,
      transparent,
      rgba(255,255,255,.18),
      transparent);

      transform:translateX(-100%);
      transition:1s;
  }

  &:hover:before{
      transform:translateX(100%);
  }

  img{
      width:100%;
      height:390px;
      object-fit:cover;
      transition:.8s;
      display:block;
  }

  &:hover img{
      transform:scale(1.12);
  }
`;

const Badge = styled.div`
  position:absolute;
  top:18px;
  left:18px;

  padding:8px 16px;

  border-radius:30px;

  background:linear-gradient(90deg,#2563eb,#7c3aed);

  color:white;

  font-size:13px;

  font-weight:bold;

  z-index:5;
`;

const Content = styled.div`
  padding:30px;
  text-align:center;
`;

const ProjectTitle = styled.h3`
  color:white;
  font-size:28px;
  margin-bottom:15px;
`;

const Description = styled.p`
  color:#d6d6d6;
  line-height:1.8;
  min-height:75px;
`;

const VisitButton = styled(Button)`
  margin-top:10px;
  border:none !important;
  border-radius:50px !important;
  padding:12px 30px !important;

  font-weight:bold !important;

  background:linear-gradient(
      90deg,
      #2563eb,
      #7c3aed
  ) !important;

  transition:.3s;

  &:hover{
      transform:scale(1.05);
      box-shadow:0 0 25px rgba(59,130,246,.6);
  }
`;

export default function UpdatedSlider() {

    const projects = [
        {
            id:1,
            title:"S.G One ניקיון ואחזקות",
            url:"https://sg1.co.il/",
            img:pp,
            desc:"עובדי ניקיון, אחזקת מבנים וניהול צוותי ניקיון."
        },
        {
            id:2,
            title:"רישוי עסקים ישראל",
            url:"https://rishuy-asakim.co.il/",
            img:p,
            desc:"ליווי מקצועי להוצאת רישיון עסק מול כל הרשויות."
        },
        {
            id:3,
            title:"אוחנה MMA",
            url:"https://teamohanamma.co.il/",
            img:n2,
            desc:"אומנויות לחימה, כושר ובניית ביטחון עצמי."
        },
        {
            id:4,
            title:"איטומים בגבהים",
            url:"https://www.itumimb.co.il/",
            img:n3,
            desc:"שיקום מבנים, איטום גגות ועבודות סנפלינג מקצועיות."
        },
            {
            id:5,
            title:"ג’ורדן אדרי הפקות ",
            url:"https://www.jordanedri.co.il/",
            img:n4,
            desc:"דיג'י ג'ורדן אדרי - מוסיקה והפקות אירועים: חתונות, בר מצוות, אירועי חברה ועוד "
        }
    ];

    return (

        <MainWrapper>

            <Title>
                העבודות <span>שלנו</span>
            </Title>

            <Subtitle>
                אנו בונים אתרי אינטרנט מהירים, מודרניים ומותאמים לקידום בגוגל,
                עם עיצוב יוקרתי וחוויית משתמש ברמה הגבוהה ביותר
            </Subtitle>

            <ProjectsGrid>

                {projects.map(project=>(

                    <Card
                        key={project.id}
                        onClick={()=>window.open(project.url,"_blank")}
                    >

                        <Badge>פרויקט</Badge>

                        <img
                            src={project.img}
                            alt={project.title}
                        />

                        <Content>

                            <ProjectTitle>
                                {project.title}
                            </ProjectTitle>

                            <Description>
                                {project.desc}
                            </Description>

                            <VisitButton>

                                צפה באתר →

                            </VisitButton>

                        </Content>

                    </Card>

                ))}

            </ProjectsGrid>

        </MainWrapper>

    );

}